module.exports = __webpack_public_path__ + "img/chatbot7.bdbfc00d.svg";